import { useI18n } from '@change-corgi/core/react/i18n';

import {
	useModalConfirmationContext,
	usePromotePageData,
	usePromotePageState,
} from 'src/app/pages/promote/pageContext';

type Result = ModelHookResult<
	{
		text: string | React.JSX.Element | React.JSX.Element[];
		cancelLabel: string;
		confirmLabel: string;
		confirmDataQa: string;
		cancelDataQa: string;
		ariaLabel: string;
		showHighAmountConfirmationModal: boolean;
	},
	{
		confirmPromotionHighAmount: () => void;
		cancelHighAmountConfirmation: () => void;
	}
>;

export function useHighAmountConfirmationModal(): Result {
	const {
		data: {
			currency: { code },
		},
	} = usePromotePageData();
	const [{ amount }] = usePromotePageState();
	const { translate, translateHtml, localizeCurrency } = useI18n();
	const [{ visibleModal }, { handleModalResult }] = useModalConfirmationContext();

	return {
		data: {
			text:
				// TODO: Move this i8n key to corgi namespace
				translateHtml('fe.pages.sponsors.confirm_high_amount_payment.modal_body', {
					amount: `<strong>${localizeCurrency(amount, code, { forceFractionDigits: true })}</strong>`,
				}),
			// TODO: Move these i8n keys to corgi namespace
			cancelLabel: translate('fe.pages.sponsors.confirm_high_amount_payment.cancel'),
			confirmLabel: translate('fe.pages.sponsors.confirm_high_amount_payment.continue'),
			confirmDataQa: 'payment-high-amount-button-confirm-yes',
			cancelDataQa: 'payment-high-amount-button-confirm-no',
			ariaLabel: translate('corgi.co.promote.high_amount_confirmation_modal.aria_label'),
			showHighAmountConfirmationModal: visibleModal === 'highAmount',
		},
		actions: {
			confirmPromotionHighAmount: () => handleModalResult(true),
			cancelHighAmountConfirmation: () => handleModalResult(false),
		},
	};
}
